const AdminIndex = () => {
  return (
    <div>
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Recusandae consectetur, quidem eligendi dignissimos ea et amet inventore? Ipsa amet veritatis impedit necessitatibus. Quis soluta ipsam ipsum temporibus fugit officia consequatur.
    </div>
  )
}

export default AdminIndex